(() => {
  const policy = document.querySelector('.shopify-policy__container');
  if (!policy) return;

  const storageKey = 'hobbytiger.privacyPolicy.textScale';
  const scales = {
    decrease: 0.8,
    reset: 1
  };
  const updatedText = 'Last updated: June 10, 2026, 16:40 JST';

  const setScale = (value) => {
    const scale = Number(value) || 1;
    policy.style.setProperty('--ht-privacy-text-scale', String(scale));

    policy.querySelectorAll('[data-privacy-text-size]').forEach((button) => {
      const buttonScale = scales[button.getAttribute('data-privacy-text-size')] || 1;
      button.setAttribute('aria-pressed', buttonScale === scale ? 'true' : 'false');
    });

    try {
      window.localStorage.setItem(storageKey, String(scale));
    } catch (error) {
      // Local storage can be unavailable in some privacy modes.
    }
  };

  const buildBreadcrumb = () => {
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'Breadcrumb');
    const breadcrumb = document.createElement('ol');
    breadcrumb.className = 'ht-privacy__breadcrumb';
    breadcrumb.innerHTML = `
      <li>
        <a class="ht-privacy__breadcrumb-home" href="/" aria-label="Home"></a>
      </li>
      <li class="ht-privacy__breadcrumb-separator" aria-hidden="true">·</li>
      <li class="ht-privacy__breadcrumb-current" aria-current="page">Privacy Policy</li>
    `;
    nav.appendChild(breadcrumb);
    return nav;
  };

  const buildControls = () => {
    const controls = document.createElement('div');
    controls.className = 'ht-privacy__text-size';
    controls.setAttribute('aria-label', 'Privacy Policy text size');
    controls.innerHTML = `
      <button class="ht-privacy__text-size-button" type="button" data-privacy-text-size="decrease" aria-label="Make Privacy Policy text smaller">A-</button>
      <button class="ht-privacy__text-size-button" type="button" data-privacy-text-size="reset" aria-label="Reset Privacy Policy text size" aria-pressed="true">A</button>
    `;
    controls.addEventListener('click', (event) => {
      const button = event.target.closest('[data-privacy-text-size]');
      if (!button) return;
      setScale(scales[button.getAttribute('data-privacy-text-size')] || 1);
    });
    return controls;
  };
  const buildContactCard = () => {
    const card = document.createElement('section');
    card.className = 'ht-privacy__contact-card';
    card.setAttribute('aria-labelledby', 'ht-privacy-contact-title');
    card.innerHTML = `
      <h2 id="ht-privacy-contact-title">Questions About Your Privacy?</h2>
      <p>If you have questions about this Privacy Policy, your personal information, or a request related to your data, contact HobbyTiger support and we will help you find the right next step.</p>
      <a class="ht-privacy__contact-link" href="/pages/contact">Contact HobbyTiger</a>
    `;
    return card;
  };
  const removeNativeContactSection = (root) => {
    const contactHeading = Array.from(root.querySelectorAll('h2')).find((heading) => (
      heading.textContent.trim().toLowerCase() === 'contact'
    ));
    if (!contactHeading) return;

    const nodesToRemove = [contactHeading];
    let next = contactHeading.nextElementSibling;
    while (next && next.tagName !== 'H2') {
      nodesToRemove.push(next);
      next = next.nextElementSibling;
    }

    nodesToRemove.forEach((node) => node.remove());
  };
  const wrapListItemContent = (root) => {
    root.querySelectorAll('li').forEach((item) => {
      if (item.querySelector(':scope > .ht-privacy__li-content')) return;

      const content = document.createElement('span');
      content.className = 'ht-privacy__li-content';
      while (item.firstChild) {
        content.appendChild(item.firstChild);
      }
      item.appendChild(content);
    });
  };

  const title = policy.querySelector('.shopify-policy__title');
  const body = policy.querySelector('.shopify-policy__body');
  const firstParagraph = body?.querySelector('.rte p');

  policy.classList.add('ht-privacy');

  if (title && !policy.querySelector('.ht-privacy__breadcrumb')) {
    policy.insertBefore(buildBreadcrumb(), title);
  }

  title?.querySelector('h1')?.replaceChildren('Privacy Policy');

  if (!policy.querySelector('.ht-privacy__text-size')) {
    policy.insertBefore(buildControls(), policy.firstElementChild);
  }

  if (firstParagraph && /^last updated:/i.test(firstParagraph.textContent.trim())) {
    firstParagraph.textContent = updatedText;
    firstParagraph.classList.add('ht-privacy__updated');
  }

  if (body) {
    removeNativeContactSection(body);
    wrapListItemContent(body);
  }

  if (body && !body.querySelector('.ht-privacy__contact-card')) {
    body.querySelector('.rte > div, .rte')?.appendChild(buildContactCard());
  }

  try {
    setScale(window.localStorage.getItem(storageKey) || '1');
  } catch (error) {
    setScale(1);
  }
})();
